module.exports = __webpack_public_path__ + "img/caseimeiopposcan.7df03837.png";